<template>
    <div component="VideoGalleryUpload">
        <input type="file" id="inputFile" ref="inputFile" @change="validateFile" :accept="validMimes" multiple />
        <btn
            v-if="getIsLoggedIn && !getIsSetActorAccessToken"
            ref="uploadBtn"
            class="button"
            :color="'accent'"
            :icon="'add'"
            :text="'Upload video'"
            :state="uploading ? 'load' : ''"
            @click="openFileBrowser"
        />
        <div class="response" v-if="response">{{ response }}</div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

const maxFileSizeMb = 300;

const validMimes = ['video/mp4', 'video/quicktime'];

export default {
    name: 'VideoGalleryUpload',

    props: {
        uploading: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            validMimes: validMimes.join(','),
            selectedFile: null,
            state: '',
            saving: false,
            errorTimeout: 3000,
            response: '',
        };
    },

    methods: {
        ...mapActions(['uploadActorVideo']),

        openFileBrowser() {
            if (!this.uploading) {
                this.$refs.inputFile.click();
            }
        },

        error(message) {
            this.$refs.inputFile.value = '';
            this.$refs.uploadBtn.setError('Upload Error', this.errorTimeout);
            this.setResponse(message);
        },

        validateFile(event) {
            const files = event.target.files;

            Array.from(files).forEach((file) => {
                if (!file) {
                    event.preventDefault();
                    this.$env.log.info('No file chosen');
                    return;
                }

                this.$bugsnag.leaveBreadcrumb('Validating portfolio video', {
                    name: file.name,
                    size: file.size,
                    mime: file.type,
                });

                // In case of html input edit in inspect window
                if (!validMimes.includes(file.type)) {
                    const e = 'Please select MP4 video file';
                    this.$bugsnag.notify(e);
                    return this.error(e);
                }

                if (file.size / 1024 / 1024 > maxFileSizeMb) {
                    event.preventDefault();
                    this.$refs.uploadBtn.setError('Upload Error', this.errorTimeout);
                    this.setResponse('Video file is too big. Limit is ' + maxFileSizeMb + ' MB');
                    return;
                }

                this.$emit('submit', file);
            });
        },

        setResponse(response) {
            this.response = response;

            setTimeout(() => {
                this.response = null;
            }, this.errorTimeout);
        },
    },

    computed: {
        ...mapGetters(['getIsLoggedIn', 'getIsSetActorAccessToken']),
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoGalleryUpload'] {
    position: relative;

    #inputFile {
        display: none;
    }

    .response {
        position: absolute;
        top: 100%;
        left: 0;
        padding: 7px 11px;
        background: @error;
        border-radius: 4px;
        color: white;
        font-size: 14px;
        margin-top: 3px;
        line-height: 1.3;
    }
}
</style>
